export type LoginType = 'LAB4U' | 'GOOGLE' | 'MICROSOFT';

/** Human readable name of each login provider, used in error messages */
export const LOGIN_TYPE_DISPLAY_NAME: Record<LoginType, string> = {
  LAB4U: 'Lab4U',
  GOOGLE: 'Google',
  MICROSOFT: 'Microsoft',
};

export interface LoginAttempt {
  email?: string;
  loginType: LoginType;
}
